import * as ENUM_LABELS from "../labels/enum";

export const LABELS: Record<string, string> = {
    [ENUM_LABELS.CONVENIENCE_STORE_SEVEN_ELEVEN]: "Seven Eleven",
    [ENUM_LABELS.CONVENIENCE_STORE_FAMILY_MART]: "FamilyMart",
    [ENUM_LABELS.CONVENIENCE_STORE_LAWSON]: "Lawson",
    [ENUM_LABELS.CONVENIENCE_STORE_MINI_STOP]: "Ministop",
    [ENUM_LABELS.CONVENIENCE_STORE_SEICO_MART]: "Seico Mart",
    [ENUM_LABELS.CONVENIENCE_STORE_DAILY_YAMAZAKI]: "Daily Yamazaki",
    [ENUM_LABELS.CONVENIENCE_STORE_PAY_EASY]: "Pay-easy",
    [ENUM_LABELS.CONVENIENCE_STORE_YAMAZAKI_DAILY_STORE]: "Yamazaki Daily",

    [ENUM_LABELS.CARD_VISA]: "Visa",
    [ENUM_LABELS.CARD_AMEX]: "American Express",
    [ENUM_LABELS.CARD_MASTERCARD]: "MasterCard",
    [ENUM_LABELS.CARD_MAESTRO]: "Maestro",
    [ENUM_LABELS.CARD_DISCOVER]: "Discover",
    [ENUM_LABELS.CARD_JCB]: "JCB",
    [ENUM_LABELS.CARD_DINERS]: "Cuners Club",
    [ENUM_LABELS.CARD_UNIONPAY]: "UnionPay",
};

export default LABELS;
